<div class="save-template-layout">
  <div class="loader-content" *ngIf="isLoading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">{{ loaderMessage }}</div>
    </div>
  </div>
  <div class="container" *ngIf="!isLoading">
    <div>
      <span class="header-title">
        <i class="mdi mdi-content-save"></i>
        <span class="title">{{ title }}</span>
      </span>
    </div>
    <div class="container-body">
      <div class="inner-body">
        <form name="saveTemplate" #saveTemplate="ngForm">
          <div class="form-inputs">
            <div>
              <div class="label"><b>Template name</b></div>
              <input
                matInput
                autocomplete="off"
                class="width100"
                type="text"
                [(ngModel)]="formData.templateName"
                (ngModelChange)="onChangeName(formData.templateName)"
                name="templateName"
                #templateNameInput="ngModel"
                maxlength="40"
                required
              />
              <div
                class="error"
                *ngIf="
                  templateNameInput.invalid &&
                  (templateNameInput.dirty || templateNameInput.touched)
                "
              >
                <mat-error *ngIf="templateNameInput.errors.required">Name is required.</mat-error>
              </div>
            </div>
          </div>
          <div class="form-inputs">
            <div *ngIf="hasReadWriteRole">
              <mat-checkbox
                [checked]="formData.shareTemplate"
                [(ngModel)]="formData.shareTemplate"
                name="shareTemplate"
                color="primary"
              >
                <div class="label">
                  <b>Share this template with others </b>
                </div>
              </mat-checkbox>
            </div>
          </div>
        </form>
      </div>
      <div class="btn-align">
        <button
          mat-flat-button
          *ngIf="!templateService.getTemplateId()"
          [disabled]="templateNameInput.invalid"
          (click)="saveTemplateConfig()"
        >
          Save
        </button>
        <button
          mat-flat-button
          *ngIf="templateService.getTemplateId()"
          [disabled]="templateNameInput.invalid"
          (click)="updateTemplateConfig()"
        >
          Update
        </button>
        <button
          mat-flat-button
          *ngIf="templateService.getTemplateId()"
          [disabled]="templateNameInput.invalid || isNameChanged"
          (click)="saveTemplateConfig()"
        >
          Create New
        </button>
        <button mat-stroked-button class="save-btn cancel" mat-dialog-close>CANCEL</button>
      </div>
    </div>
  </div>
</div>
